define('editor/edit/layers/helpers',['plugins/http', 'knockout'], function (http, ko) {
    var viewmodel = function() {
        var self = this;

        self.getMapLayers = function(editorMapId) {
            var layersUrl = "/api/editor/layers",
                data = {
                    editorMapId: editorMapId
                };

            return http.get(layersUrl, data)
                .then(function(response) {
                    if (response.data) {
                        return response.data.layers;
                    }
                    return null;
                });
        };

        self.getIcons = function() {
            var url = '/api/editor/icons';

            return http.get(url).then(function(response) {
                // group icons into category heirarchy
                var result = [];
                var icons = response.data.icons;
                var categories = ko.utils.arrayMap(icons, function(icon) {
                    return icon.categoryName;
                });

                var uniqueCategories = ko.utils.arrayGetDistinctValues(categories).sort();
                var categoriesLen = uniqueCategories.length;

                for (var i = 0; i < categoriesLen; i++) {
                    var catName = uniqueCategories[i];
                    var groupedIconsByCategory = {
                        name: catName,
                        icons: ko.observableArray([])
                    };

                    var categoryIcons = ko.utils.arrayFilter(icons, function(icon) {
                        return icon.categoryName === catName;
                    });

                    ko.utils.arrayPushAll(groupedIconsByCategory.icons(), categoryIcons);

                    result.push(groupedIconsByCategory);
                }
                return result;
            });
        };
    };

    return new viewmodel();
});

